/* eslint-disable no-console */
import Config from '../../app.config';

const reCaptchaV3Plugin = action => {
  try {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.RECAPTCHA_SITE_KEY, {
          action,
        })
        .then(token => {
          fetch(`${Config.apiBasev2}/verifyrecaptcha`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
          })
            .then(res => res.json())
            .then(data =>
              console.log(`reCaptchaV3 Response on ${action}:`, data.success),
            )
            .catch(err =>
              console.log('reCaptchaV3 init error - /verifyrecaptcha:', err),
            );
        });
    });
  } catch (err) {
    console.log('reCaptchaV3Plugin utility function failure:', err);
  }
};

export default reCaptchaV3Plugin;
